<template>
  <!-- 我的订单 -->
  <div class='my-order'>
    <sub-nav :navs='navs' />
    <h2>{{ orderTypeText }}</h2>
    <div class='content'>
      <div v-loading='loading' class='table-wrapper'>
        <!-- 列表 团体订单-->
        <table v-if='orderGroup==="group"' class='table'>
          <thead>
            <tr>
              <td v-for='item in tables' :style='{width:item.width}' :key='item.idx' >{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in tables' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "apply_refund"' class='cell'>
                  <a v-if='item.status === 1' href='javascript:;' @click='apply2Refund(item)'>申请退款</a>
                </div>
                <div v-else class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>

        <!-- 列表 个人订单 -->
        <table v-else class='table-person'>
          <thead>
            <tr>
              <td v-for='item in personTableItems' :style='{width:item.width}' :key='item.idx' >{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in personTableItems' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "apply_refund"' class='cell'>
                  <a href='javascript:;' @click='apply2RefundPerson(item)'>申请退款</a>
                </div>
                <div v-else class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <page :total='total' @change='changePage'/>
      <div class='btn-wrapper'>
        <a href='javascript:;' @click='goBack'>返回</a>
      </div>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page'
import SubNav from '@/components/SubNav'

import { MEMBER_ORDER,MEMBER_ORDER_PERSON } from '@/api'

export default {
  components: {
    Page,
    SubNav
  },

  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'discount':
          result = val + '%'
          break
        default:
          result = val
      }
      return result
    }
  },
  data() {
    return {
      navs: [{label: '个人中心', path: '/my'}],
      msg: '',
      page: 1,
      total: 0,
      loading: false,
      groupTableItems: [    // 团体订单
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 8, label: '批发单号', props: 'wholesale_no', width: '120px'},
        { idx: 10, label: '书名', props: 'book_name',width: '220px'},
        { idx: 9, label: '书号', props: 'book_no', width: '150px'},
        { idx: 15, label: '索引', props: 'indexes',width: '60px'},
        { idx: 3, label: '学校', props: 'school', width: '100px'},
        { idx: 4, label: '院系', props: 'department', width: '120px'},
        { idx: 5, label: '年级专业班级', props: 'profession_class',width: '120px'},
        { idx: 12, label: '价格', props: 'price',width: '80px'},
        { idx: 13, label: '折扣', props: 'discount',width: '70px'},
        { idx: 14, label: '数量', props: 'pay_num',width: '50px'},
        { idx: 16, label: '付款状态', props: 'statusTxt',width: '120px'},      // 状态 1:已付款， 2：退款审核中; 3:退款完成; 4:退款拒绝, 5:已配货, 6:退款审核通过，退款中
        { idx: 17, label: '申请退款', props: 'apply_refund',width: '120px'},
      ],
      personTableItems: [    // 个人
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 2, label: '交易单号', props: 'pay_order_no', width: '120px'},
        { idx: 3, label: '日期', props: 'gmt_create',width: '220px'},
        { idx: 4, label: '数量', props: 'pay_num', width: '150px'},
        { idx: 5, label: '实付款（￥）', props: 'total_price',width: '80px'},
        { idx: 6, label: '申请退款', props: 'apply_refund',width: '120px'},
      ],
      list: []
    }
  },

  computed: {
    // 订单类型: 全部 已付款 未付款
    orderType() {
      return this.$route.params.type.split('_')[1] 
    },

    // 团体订单 or 个人订单
    orderGroup() {
      return this.$route.params.type.split('_')[0] 
    },
        
    // 订单类型-title
    orderTypeText() {
      return this.$route.params.type.split('_')[1] === 'ispay' ? '已付款订单' : (this.$route.params.type.split('_')[1] === 'all' ? '全部订单' : '已退款订单')
    },

    // 格式化tableItems
    tables() {
      let groupTableItems = this.groupTableItems
      if (this.$route.params.type.split('_')[1] === 'isrefund') {
        groupTableItems.pop()  // 已退款订单 去掉申请退款列
        return groupTableItems
      } else {
        return groupTableItems
      }
    }

  },

  created() {
    this.getOrder()
    this.setActiveBar('MY')
  },

  methods: {
    // 申请退款-团体
    apply2Refund(order) {
      this.$store.commit('setRefundOrder',order)
      this.goRouter('/apply2refund')
    },

    // 申请退款-个人
    apply2RefundPerson(order) {
      let payload = {
        key: 'payOrderNo',
        val: order.pay_order_no
      }
      this.$store.commit('updateStrData',payload)
      this.goRouter('/myorderperson')
    },

    // 翻页
    changePage(val) {
      this.page = val
      this.getOrder()
    },

    // 格式化订单状态
    _formatStatus(status) {
      let txt
      switch (status) {
        case 1:
          txt = '已付款'
          break
        case 2:
          txt = '退款审核中'
          break
        case 3:
          txt = '退款完成'
          break
        case 4:
          txt = '拒绝退款'
          break
        case 5:
          txt = '已配货'
          break
        case 6:
          txt = '审核通过，退款中'
          break
        default:
          txt = ''
          break
      }
      return txt
    },

    // 获取订单
    getOrder() {
      if (this.orderGroup === 'group') this.getGroupOrder()
      else this.getPersonOrder()
    },

    // 获取订单-团体
    getGroupOrder() {
      let para = {
        page: this.page
      }
      this.loading = true
      MEMBER_ORDER(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this._formatList(res.data.data)
          this.total = res.data.total
        } else {
          this.$notify(res.data.msg,'warning')
        }
      })
    },

    // 获取订单-个人
    getPersonOrder() {
      let para = {
        page: this.page
      }
      this.loading = true
      MEMBER_ORDER_PERSON(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this._formatListPerson(res.data.data)
          this.total = res.data.total
        } else {
          this.$notify(res.data.msg,'warning')
        }
      })
    },
    
    // 格式化列表-个人订单
    _formatListPerson(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        this.list.push(e)
      })
    },

    // 格式化列表-团体订单
    _formatList(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        e.statusTxt = this._formatStatus(e.status)
        if (this.orderType === 'isrefund') {  
          if (e.status === 3) {
            this.list.push(e)
          }
        } else if (this.orderType === 'ispay') {
          if (e.status === 1) {
            this.list.push(e)
          }
        } else {
          this.list.push(e)
        }
      })
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.my-order {
  width: 1200px;

  h2 {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: 500;
  }
  .content {
    width: 1200px;
    position: relative;
    margin-top: 30px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      position: relative;

      // 列表-团体订单
      .table {
        width: 1500px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }

      // 列表-个人订单
      .table-person {
        width: 1200px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }

    .btn-wrapper {
      margin-top: 50px;

      a {
        display: block;
        height: 38px;
        line-height: 38px;
        width: 298px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        background: @blue-d;
        border-radius: 5px;
        margin: 0 auto;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/MyOrder.vue